import React from 'react';
import HelpPanelLink from '@atlassian/jira-help-panel-button';
import { FormattedMessage, useIntl } from '@atlassian/jira-intl';
import type { MessageDescriptorV2 as MessageDescriptor } from '@atlassian/jira-intl/src/v2/types.tsx';
import { fireUIAnalytics, useAnalyticsEvents } from '@atlassian/jira-product-analytics-bridge';

const FeatureDescription = ({
	description,
	learnMoreLink,
	inProductHelpArticleId,
	descriptionForIPH,
	learnMoreLinkText,
	learnMoreLinkClickEventName,
}: {
	description: MessageDescriptor;
	learnMoreLink: string;
	inProductHelpArticleId: string;
	descriptionForIPH: MessageDescriptor;
	learnMoreLinkText: MessageDescriptor;
	learnMoreLinkClickEventName: string;
}) => {
	const { formatMessage } = useIntl();
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const descriptionMessage = (
		<FormattedMessage
			{...description}
			values={{
				href: learnMoreLink,
			}}
		/>
	);
	if (inProductHelpArticleId && learnMoreLinkText) {
		const fallBackLink = (
			<a target="_blank" href={learnMoreLink}>
				{formatMessage(learnMoreLinkText)}
			</a>
		);
		const inProductHelpLink = (
			<HelpPanelLink
				appearance="link"
				spacing="none"
				articleId={inProductHelpArticleId}
				fallbackComponent={fallBackLink}
				onClick={() =>
					fireUIAnalytics(
						createAnalyticsEvent({}),
						'helpLink clicked',
						learnMoreLinkClickEventName,
						{
							articleId: inProductHelpArticleId,
						},
					)
				}
			>
				{formatMessage(learnMoreLinkText)}
			</HelpPanelLink>
		);
		return (
			<FormattedMessage
				{...descriptionForIPH}
				values={{
					learnMoreLink: inProductHelpLink,
					br: (
						<>
							<br />
							<br />
						</>
					),
				}}
			/>
		);
	}
	return descriptionMessage;
};

export default FeatureDescription;
